var html = document.documentElement;
var body = document.body;

burger();
lazyLoad();
resEmb();
gallery();

//niteMode();



//Burger
function burger() {
    'use strict';
    var itBurger = document.querySelector('.it-burger');
    if (itBurger){
        itBurger.addEventListener('click', function() {
            body.classList.toggle("it-head-open");
        });
    }
}

// //dropdown
// function dropdown() {
//     const navs = document.querySelectorAll(".dropdown"),
//           t = document.querySelector(".dropdown");

//           if (navs) {

//             navs.forEach(function (item) {
//                 item.addEventListener(
//                     "click",
//                     function () {
//                         this.classList.toggle("sub-active");
//                     },
//                     !1
//                 );
//             });

//           } 
//         document.addEventListener("click", function (item) {
//             item.target.closest(".dropdown") || t.classList.remove("sub-active");
//         });
// }

//Lazy Load
function lazyLoad() {
    'use strict';
    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        use_native: true
    });
    lazyLoadInstance.update();
}


//Responsive Embed

function resEmb() {
    'use strict';
    (function(global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
            typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.resemb = factory());
    }(this, (function() {
        'use strict';

        function resemb(target, cName) {
            var frames = typeof target === 'string' ? document.querySelectorAll(target) : target;
            var c = cName || 'js-resemb';
            if (!('length' in frames)) frames = [frames];
            for (var i = 0; i < frames.length; i += 1) {
                var frame = frames[i];
                var hasClass = frame.className.split(' ').indexOf(c) !== -1;
                if (hasClass || frame.style.width.indexOf('%') > -1) continue;
                var h = frame.getAttribute('height') || frame.offsetHeight;
                var w = frame.getAttribute('width') || frame.offsetWidth;
                var padding = h / w * 100;
                var div = document.createElement('div');
                div.className = c;
                var divStyles = div.style;
                divStyles.position = 'relative';
                divStyles.width = '100%';
                divStyles.paddingTop = padding + "%";
                var frameStyle = frame.style;
                frameStyle.position = 'absolute';
                frameStyle.width = '100%';
                frameStyle.height = '100%';
                frameStyle.left = '0';
                frameStyle.top = '0';
                frame.parentNode.insertBefore(div, frame);
                frame.parentNode.removeChild(frame);
                div.appendChild(frame);
            }
        }

        return resemb;

    })));

    resemb(document.querySelectorAll('.kg-embed-card iframe'))
}

// Gallery

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach(function(image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
        pswp(
            '.kg-gallery-container',
            '.kg-gallery-image',
            '.kg-gallery-image',
            false,
            true
        );
    });
}



// // Search
// function search() {

//     var searchButton = document.querySelectorAll('.v-search-button');
//     var searchBox = document.querySelector('.v-search-box');
//     var searchClose = document.getElementById('searchClose');
//     var searchInput = document.getElementById('searchInput');
//     var searchResult = document.getElementById('searchResults');

//     if (typeof searchApi !== 'undefined' && searchApi != null && searchInput != null) {
//         searchButton.forEach(function(sb) {
//             sb.addEventListener('click', function(e) {
//                 e.preventDefault();
//                 searchBox.classList.add('v-search-box-visible');
//                 body.classList.add('v-search-opened');
//                 window.setTimeout(function() {
//                     searchInput.focus();
//                 }, 200);
//             })
//         });
//         var searchinGhost = new SearchinGhost({
//             key: searchApi,
//             version: 'v4',
//             inputId: ['searchInput'],
//             outputId: ['searchResults'],
//             outputChildsType: 'div',
//             limit: 10,
//             postsFields: ['title', 'url', 'excerpt', 'custom_excerpt', 'published_at'],
//             postsExtraFields: ['tags'],
//             template: function(post) {
//                 var o = '';
//                 o += '<a href="' + post.url + '">';
//                 o += '<h3 class="v-search-title"><span>' + post.title + '</span></h3> <div class="v-search-meta">';
//                 o += '<time>' + post.published_at + '</time></div></a>';
//                 return o;
//             },
//             onSearchEnd: function(posts) {
//                 if (searchResult.scrollHeight > searchResult.offsetHeight) {
//                     searchResult.style.paddingRight = "8px";
//                 } else {
//                     searchResult.style.paddingRight = "0px";
//                 }
//             }
//         });
//         document.addEventListener('keyup', function(e) {
//             if (e.keyCode == 27 && searchBox.classList.contains('v-search-box-visible') && body.classList.contains('v-search-opened')) {
//                 closeSearch();
//             }
//         });
//         searchInput.addEventListener('keyup', function(e) {
//             if (e.keyCode == 27) {
//                 closeSearch();
//             }
//         });
//         searchClose.addEventListener('keyup', function(e) {
//             if (e.keyCode == 13) {
//                 closeSearch();
//             }
//         });
//         searchClose.addEventListener('keyup', function(e) {
//             if (e.keyCode == 13) {
//                 closeSearch();
//             }
//         });
//         searchBox.onclick = closeSearch;
//         searchClose.onclick = closeSearch;

//         function closeSearch(e) {

//             if (e !== undefined && e.target !== e.currentTarget) {
//                 return;
//             }
//             searchBox.classList.toggle('v-search-box-visible');
//             body.classList.toggle('v-search-opened');
//             searchInput.value = '';
//             searchResult.innerHTML = '';
//         }
//     }
// }



//DarkMode

// function niteMode() {
//     var darkLight = document.querySelector('.dark-light');
//     darkLight.addEventListener('click', function(){
//     if(html.getAttribute('data-theme') === 'dark'){
//         html.setAttribute('data-theme', 'light')
//         localStorage.setItem('selected-theme', 'light');
//     }else{
//         html.setAttribute('data-theme', 'dark')
//         localStorage.setItem('selected-theme', 'dark');
//     }
//     });
// }

function pswp(container, element, trigger, caption, isGallery) {
    var parseThumbnailElements = function (el) {
        var items = [],
            gridEl,
            linkEl,
            item;

        el
            .querySelectorAll(element)
            .forEach(function (v) {
                gridEl = v;
                linkEl = gridEl.querySelector(trigger);

                item = {
                    src: isGallery
                        ? gridEl.querySelector('img').getAttribute('src')
                        : linkEl.getAttribute('href'),
                    w: 0,
                    h: 0,
                };

                if (caption && gridEl.querySelector(caption)) {
                    item.title = gridEl.querySelector(caption).innerHTML;
                }

                items.push(item);
            });

        return items;
    };

    var openPhotoSwipe = function (index, galleryElement) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        options = {
            closeOnScroll: false,
            history: false,
            index: index,
            shareEl: false,
            showAnimationDuration: 0,
            showHideOpacity: true,
        };

        gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
        );
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                var img = new Image();
                img.onload = function () {
                    item.w = this.width; 
                    item.h = this.height; 
                    gallery.updateSize(true); 
                };
                img.src = item.src; 
            }
        });
        gallery.init();
    };

    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var siblings = e.target.closest(container).querySelectorAll(element);
        var nodes = Array.prototype.slice.call(siblings);
        var index = nodes.indexOf(e.target.closest(element));
        var clickedGallery = e.target.closest(container);

        openPhotoSwipe(index, clickedGallery);

        return false;
    };

    var triggers = document.querySelectorAll(trigger);
    triggers.forEach(function (trig) {
        trig.addEventListener('click', function (e) {
            onThumbnailsClick(e);
        });
    });
}


document.addEventListener("DOMContentLoaded", function() {
    document.documentElement.classList.add("js-loaded");
});